/** Bytes as megabytes, localised (PDG-D9). */
export const formatFileSize = (bytes: number, language: string): string => {
  const megabytes = bytes / 1_048_576;
  const format = new Intl.NumberFormat(language, { maximumFractionDigits: 1 });
  return `${format.format(megabytes)} MB`;
};
